var _circle, _circle2, _path, _path2, _path3, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompassRights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9991,
    cy: 20.9933,
    r: 18.3014,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.57895
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9985,
    cy: 20.9922,
    r: 14.2105,
    fill: "white",
    stroke: "#081E54",
    strokeWidth: 1.57895
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4937 15.3157L22.6886 23.6198L18.1029 18.9256L26.4937 15.3157Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.52 26.5743L21.9981 22.7952L17.2765 18.0861L13.52 26.5743Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.045 18.0376L22.9541 23.9467M17.045 18.0376L27.4995 13.4922L22.9541 23.9467M17.045 18.0376L12.4995 28.4922L22.9541 23.9467",
    stroke: "#081E54",
    strokeWidth: 1.05263,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.3344,
    y1: 7.23479,
    x2: 20.3344,
    y2: 9.2922,
    stroke: "#081E54",
    strokeWidth: 1.57895,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.7554,
    y1: 21.3324,
    x2: 31.698,
    y2: 21.3324,
    stroke: "#081E54",
    strokeWidth: 1.57895,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.3344,
    y1: 32.6918,
    x2: 20.3344,
    y2: 34.7492,
    stroke: "#081E54",
    strokeWidth: 1.57895,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.30135,
    y1: 21.3324,
    x2: 6.24393,
    y2: 21.3324,
    stroke: "#081E54",
    strokeWidth: 1.57895,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassRights);
export default __webpack_public_path__ + "static/media/CompassRights.4fbd2b6055df85e9e285556cd868d655.svg";
export { ForwardRef as ReactComponent };